import { authMethod } from '../secure-portal/auth/Auth.constants';
import { Environment } from './environment.types';
import { filterNavigation } from './navigation';

const environment: Partial<Environment> = {
  apiBaseUrl: 'https://domino-qms-api.sierralabs.com/api/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true,
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  recaptchaSiteKey: '6LfLJtQjAAAAAF5Eymo01VfMF2qxtY7C1r8j-MxT',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Risk Management',
    'Documents',
    'Products',
    'Hazards',
    'CAPA',
    'SCAR',
    'Change Order',
    'Supplier Management',
    'Teams',
    'Employees',
    'Forms',
    'Workflow',
    'Task Types',
    'Templates'
  ),
  changeOrderConfig: { useCustomFields: true },
  authConfig: { methods: [authMethod.default, authMethod.google] },
  googleAuthConfig: {
    clientId:
      '210722378610-cjreoptgvqfdklt3dfc32m8308arqj74.apps.googleusercontent.com'
  },
  organizationConfig: { enabled: true }
};

export default environment;
